/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import '@xengage/gw-platform-translations';
import metadata from './MLReadOnlyCovTermComponent.metadata.json5';
import styles from './MLReadOnlyCovTermComponent.module.scss';

function MLReadOnlyCovTermComponent(props) {
    const {
        coverage,
        index,
        getChosenTermValue,
        displayBeforeReadMoreContent,
        displayHelpMessage,
        isDescriptionDuplicated,
        hasReadMore,
        getPopoverContent,
        isSelfInsuredRetention,
        showPremium,
        showMonthlyPremium,
        monthlyPremiumEvaluator,
        isModernProduct,
        isOccupancySecondaryOrSeasonal
    } = props;

    const getCoveragePremium = useCallback((cov) => {
        if (showMonthlyPremium) {
            let monthlyAmount;
            if (monthlyPremiumEvaluator) {
                const func = monthlyPremiumEvaluator.evaluatorFunction;
                const ctx = monthlyPremiumEvaluator.context;
                monthlyAmount = func(cov, ctx);
            } else {
                monthlyAmount = cov.monthlyAmount_ML;
            }
            return monthlyAmount || '-';
        }

        if (cov.premium) {
            return cov.premium;
        }

        if (cov.amount) {
            return cov.amount;
        }

        return 0;
    }, [monthlyPremiumEvaluator, showMonthlyPremium]);

    const resolvers = {
        resolveClassNameMap: styles
    };

    const generateTermOverrides = useCallback(() => {
        const termOverrides = coverage.terms.map((term, termIndex) => {           
        const hideTermValueForCoverage = isOccupancySecondaryOrSeasonal && ['HOPCovE', 'HOPCovF'].includes(coverage?.code_ML);
            return {
                [`termTableRow${index}${termIndex}`]: {
                    className: (showPremium || showMonthlyPremium) ? 'table-row three-columns' : 'table-row',
                    visible: term.isVisible_ML
                },
                [`tooltipTermContainer${index}${termIndex}`]: {
                    visible: displayHelpMessage && term.description && !isDescriptionDuplicated(term)
                },
                [`termDescTooltip${index}${termIndex}`]: {
                    tooltipContent: getPopoverContent(term)
                },
                [`termReadMore${index}${termIndex}`]: {
                    visible: hasReadMore(term),
                    content: hasReadMore(term) && displayBeforeReadMoreContent(term)
                },
                 [`covTermNameSpan${index}${termIndex}`]: {
                    content: hideTermValueForCoverage ?' Extended from Primary' :term?.name,
                },
                [`termValue${index}${termIndex}`]: {
                    visible : !hideTermValueForCoverage,
                    content: getChosenTermValue(term),                  
                    className: (showPremium || showMonthlyPremium) ? 'mid-column' : 'right-column',
                },
                [`termPremiumDiv${index}${termIndex}`]: {
                    visible: ((showPremium || showMonthlyPremium) && termIndex === 0 && !isSelfInsuredRetention(coverage))
                        || ((showPremium || showMonthlyPremium) && termIndex !== 0) || isSelfInsuredRetention(coverage),
                    content: getCoveragePremium(coverage)
                },
                [`termPremiumSpan${index}${termIndex}`]: {
                    visible: !!(showPremium || showMonthlyPremium) && termIndex === 0 && !isSelfInsuredRetention(coverage),
                    content: getCoveragePremium(coverage)
                },
            };
        });

        return Object.assign({}, ...termOverrides);
    }, [coverage, index, showPremium, showMonthlyPremium, displayHelpMessage, isDescriptionDuplicated, getPopoverContent, hasReadMore, displayBeforeReadMoreContent, getChosenTermValue, isSelfInsuredRetention, getCoveragePremium]);

    const overrides = {
        [`covTermLoop${index}`]: {
            data: coverage.terms
        },
        ...generateTermOverrides()
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, index);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLReadOnlyCovTermComponent.propTypes = {
    coverage: PropTypes.shape({}),
    index: PropTypes.number,
    getChosenTermValue: PropTypes.func,
    displayBeforeReadMoreContent: PropTypes.func,
    displayHelpMessage: PropTypes.bool,
    isDescriptionDuplicated: PropTypes.func,
    hasReadMore: PropTypes.func,
    getPopoverContent: PropTypes.func,
    isSelfInsuredRetention: PropTypes.func,
    showPremium: PropTypes.bool,
    showMonthlyPremium: PropTypes.bool,
    monthlyPremiumEvaluator: PropTypes.func
};

export default MLReadOnlyCovTermComponent;
